<template>
  <div>
    <!-- 即使 JS 卡死，用户至少能看到文字，不会是全白 -->
    <div>登录中，请稍候...</div>
  </div>
</template>

<script>
// CDN 动态加载 vConsole，只在带 ?vcon 参数时开
if (window.location.search.includes('vcon')) {
  const script = document.createElement('script');
  script.src = 'https://unpkg.com/vconsole@3.15.1/dist/vconsole.min.js';
  script.onload = () => {
    new VConsole();
    console.log('🚀 vConsole 已加载');
  };
  document.head.appendChild(script);
}
console.log('🚀 页面脚本开始执行，当前URL：', window.location.href);
console.log('🚀 当前URL hash：', window.location.hash);
import { wxLogin } from "@/api/login";
import wx from "weixin-js-sdk";
// const wx = window.wx

export default {
  beforeCreate() {
    console.log('🚀 beforeCreate');
  },
  created() {
    console.log('🚀 created, $route:', this.$route);
  },
  // 关键：不在这个页面的 data 里放任何 window 对象或复杂引用
  data() {
    console.log('🚀 data() running');
    return {
      // 只保留基础数据
      code:"",
    };
  },
  mounted() {
    console.log('🚀 mounted');
    // alert(`href: ${window.location.href}\nsearch: ${window.location.search}\nhash: ${window.location.hash}`);
    // --- 方案核心：使用原生 JS 获取 URL 参数，脱离 Vue Router ---
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    console.log('🚀 window.location.search:',window.location.search);
    console.log('🚀 code',code);

    // 如果没有 code，直接打回，防止空转
    if (!code) {
      alert('获取登录凭证失败（缺少code），将返回小程序');
      wx.miniProgram.reLaunch({
        url: "/pages/login/login"
      });
      return;
    }

    // 发起登录请求
    wxLogin({ code: code })
        .then((res) => {
          // --- 方案核心：防御性极强的数据解析 ---
          // 1. 检查 res 是否存在
          // 2. 检查 res.data 是否是对象（防止返回HTML）
          // 3. 直接取 data，不做多层解构
          if (!res || typeof res.data !== 'object') {
            throw new Error('接口返回数据格式异常');
          }

          const apiData = res.data.data; // 直接读，不嵌套解构
          const loginCredential = apiData?.loginCredential;
          const userId = apiData?.userid;

          if (loginCredential) {
            const redirectParams = new URLSearchParams();
            redirectParams.set("mpCredential", loginCredential);
            if (userId) {
              redirectParams.set("mpUserid", userId);
              redirectParams.set("mpOpenid", apiData.openid || "");
              redirectParams.set("mpAccess", apiData.token || "");
            } else {
              redirectParams.set("mpUserid", "0");
            }
            const redirectUrl = `/pages/login/login?${redirectParams.toString()}`;

            wx.miniProgram.reLaunch({
              url: redirectUrl,
              fail: (err) => {
                alert('跳转小程序失败，请重试');
                console.error('Relaunch Fail:', err);
              }
            });
          } else {
            // 未绑定用户等情况
            wx.miniProgram.reLaunch({
              url: "/pages/login/login?mpUserid=0"
            });
          }
        })
        .catch((err) => {
          // --- 方案核心：iOS 白屏克星 ---
          // 不用 this.$message（可能渲染不出来），直接用 alert
          console.error('Login Error:', err);
          alert('登录失败，请检查网络后重试');

          wx.miniProgram.reLaunch({
            url: "/pages/login/login"
          });
        });
  },
};
</script>
